<script>
export default {
  props: {
    title: String,
    optText: String
  },
  methods: {
    optClick() {
      this.$emit('clear', this.optText)
    }
  },
  render() {
    return (
      <div class="filter-title-wrap">
        <span>{this.title}</span>
        <span on-click={this.optClick}>{this.optText}</span>
      </div>
    )
  }
}
</script>